
import React from 'react';



function EditUserSelect({ label, id, onChange, idType_1, idType_2, idType_3, value, required}) {
  
  return (
    <div className="row mt-2">
      <div className="col-md-13"><label className="labels">{label}</label></div>
      <div className="col-md-14"><select id={id} name={id} value={value} onChange={onChange} required={required}>
      <option value="">Select</option>    
      {idType_1 && <option value={idType_1}>{idType_1}</option>}
      {idType_2 && <option value={idType_2}>{idType_2}</option>}
      {idType_3 && <option value={idType_3}>{idType_3}</option>}
</select>
</div>

    </div>
  );
}

export default EditUserSelect;